"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("./constants");
var _default = exports.default = {
  name: 'YsAsyncExportTable',
  props: {
    exportFn: {
      type: Function
    },
    columns: {
      type: Array,
      required: false,
      default: () => _constants.EXPORT_DEFAULT_COLUMNS
    },
    bizType: {
      type: String,
      required: true
    },
    tableWrapperClass: {
      type: String,
      default: ''
    }
  },
  inject: {
    ysProviderContext: {
      default: () => ({
        api: {}
      })
    }
  },
  data() {
    return {
      tableProps: {
        rowKey: 'id'
      },
      EXPORT_TASK_STATUS: _constants.EXPORT_TASK_STATUS,
      loading: false
    };
  },
  methods: {
    refresh() {
      this.$refs.tableRef.reload();
    },
    getExportList(params) {
      return this.ysProviderContext.api.getFileJobList({
        ...params,
        bizType: this.bizType
      });
    },
    async handleExport() {
      try {
        this.loading = true;
        await this.exportFn();
        await this.refresh();
        this.$message.success('导出成功');
      } finally {
        this.loading = false;
      }
    },
    async handleDownload(task) {
      if (task.linkUrl) {
        window.open(task.linkUrl);
        return;
      }
      await this.ysProviderContext.api.download({
        taskId: task.id
      });
      this.$message.success('下载成功');
    },
    async handleStop(taskId) {
      await this.ysProviderContext.api.stopTask({
        taskId
      });
      this.$message.success('已停止该导出任务');
      await this.refresh();
    }
  }
};